import {
  ComposeMessageDialog,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ComposeMessage/ComposeMessageDialog';
import {
  ComposeMessage,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ComposeMessage/ComposeMessage';

const OVERRIDE_MAP = {
  MessagesPageCompose: {
    onSubmit: (dockedContext, item, updatedColl) => {
      const { dockItem } = dockedContext;
      dockItem(item.key, item.title, updatedColl, {
        metaOverrideName: item.metaOverrideName,
        autoSave: false,
        saved: true,
      });
    },
    onChange: (dockedContext, item, updatedColl) => {
      const { dockItem } = dockedContext;
      dockItem(item.key, item.title, updatedColl, {
        metaOverrideName: item.metaOverrideName,
        autoSave: false,
        saved: true,
        displaySavedState: false,
      });
    },
    ChildComponentExpanded: ComposeMessage,
    ChildComponentDialog: ComposeMessageDialog,
  },
};

export default function getDockOverrides(itemKey) {
  return OVERRIDE_MAP[itemKey] || {};
}
